import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, ClockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-45">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-indigo-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-46" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col space-y-8" data-id="element-48">
          <div className="inline-flex items-center space-x-2 bg-navy-800/80 border border-navy-700 rounded-full px-4 py-2 w-fit" data-id="element-49">
            <MoonIcon className="w-4 h-4 text-amber-500" data-id="element-50" />
            <span className="text-sm font-medium text-slate-300" data-id="element-51">
              End Revenge Bedtime Procrastination
            </span>
          </div>

          <div className="space-y-4" data-id="element-52">
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight text-white" data-id="element-53">
              The{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-54">
                11PM Reset
              </span>{' '}
              Protocol
            </h1>
            <p className="text-xl sm:text-2xl font-heading font-medium text-indigo-400" data-id="element-55">
              Reclaim 2 hours of sleep every night and wake up without the
              "Digital Hangover"—even if you've been a lifelong night owl.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="bg-navy-800/50 border-l-4 border-amber-500 p-6 rounded-r-xl italic text-slate-300 text-lg leading-relaxed" data-id="element-56">
            "It's 11:45 PM. You're lying in the dark, thumb scrolling
            mindlessly, eyes burning from the blue light. You aren't even
            enjoying the content anymore, but you can't stop. Every time you
            think about locking the screen, the anxiety of tomorrow rushes in.
            You feel like the only time you truly own is the time you steal from
            your own sleep. This isn't a willpower problem—it's a biological
            loop."
          </motion.div>

          <div className="pt-4 flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-57">
            <motion.a href="https://wellnesssuccesssystem.com/cart/42808575262797:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto px-8 py-4 bg-amber-500 hover:bg-amber-600 text-navy-900 font-bold rounded-lg shadow-glow-amber transition-all duration-300 flex items-center justify-center space-x-2 text-lg no-underline" data-id="element-58">
              <span data-id="element-59">Get Instant Access for $9.99</span>
            </motion.a>
            <div className="flex items-center space-x-2 text-slate-400 text-sm" data-id="element-60">
              <ClockIcon className="w-4 h-4" data-id="element-61" />
              <span data-id="element-62">Takes just 7 minutes tonight</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="relative lg:ml-auto w-full max-w-lg xl:max-w-xl" data-id="element-63">
          <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/20 to-indigo-500/20 rounded-2xl blur-3xl transform -rotate-6" data-id="element-64" />
          <img src="https://cdn.magicpatterns.com/uploads/63S7aihheUWr9kfVzi19Ny/ideogram-v3.0_A_premium_digital_product_mockup_bundle_for_The_11PM_Reset_Protocol_featuring_a_-0.jpg" alt="The 11PM Reset Protocol Digital Bundle" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-navy-700" data-id="element-65" />
        </motion.div>
      </div>
    </section>;
}